const getStatusColor = (status, loading = false) => {
  if (loading) {
    return "#4d00d2";
  }
  if (status === "new" || status === "in_progress") {
    return "#fa9d28";
  }
  if (status === "success") {
    return "#68CE13";
  }
  if (status === "warning") {
    return "#ffde42";
  }

  return "#d20000";
};

export default getStatusColor;
